import { render, staticRenderFns } from "./EmployeeNew.vue?vue&type=template&id=4b34d278&scoped=true"
import script from "./EmployeeNew.vue?vue&type=script&lang=ts"
export * from "./EmployeeNew.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeNew.vue?vue&type=style&index=0&id=4b34d278&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b34d278",
  null
  
)

export default component.exports